<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="链接类型" prop="linkType">
      <dict-select
        v-model="form.data.linkType"
        dict-code="LINK_TYPE"/>
    </a-form-model-item>
    <a-form-model-item label="系列" prop="seriesId" v-if="form.data.linkType === 'SERIES'">
      <a-select v-model="form.data.seriesId" placeholder="请选择">
        <a-select-option
          v-for="item in series.data"
          :key="item.id"
          :title="item.name"
          :value="item.id">
          {{ item.channel }} --- {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="分类" prop="seriesId" v-if="form.data.linkType === 'CATEGORY'">
      <a-select v-model="form.data.categoryId" placeholder="请选择">
        <a-select-opt-group
          v-for="item in category.data"
          :key="item.id"
          :title="item.name"
          :value="item.id"
        >
          {{ item.name }}
          <a-select-option
            v-for="item1 in item.categoryWebsites"
            :key="item1.id"
            :title="item1.name"
            :value="item1.id">
            {{ item1.name }}
          </a-select-option>
        </a-select-opt-group>

      </a-select>
    </a-form-model-item>
    <a-form-model-item label="名称" prop="name" v-if="form.data.linkType === 'GATHER'">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="图片(400*400)" prop="coverPath" v-if="form.data.linkType === 'GATHER'">
      <div class="a-input">
        <simple-uploader-s3 v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="是否推荐" prop="isRecommended" required>
      <dict-select
        v-model="form.data.isRecommended"
        dict-code="SIMPLE_STATUS"/>
    </a-form-model-item>
    <a-form-model-item label="是否主推" prop="isPush" v-if="form.data.isRecommended === 'YES'">
      <dict-select
        v-model="form.data.isPush"
        dict-code="SIMPLE_STATUS"/>
    </a-form-model-item>

    <a-form-model-item>
     <a-space>
       <a-button type="primary" v-if="!goodsCategoryId" @click="onAdd">创建</a-button>
       <a-button type="primary" v-if="goodsCategoryId" @click="onUpdate">更新</a-button>
       <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
     </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsGathers,
  _queryGather,
  _addGather,
  _updateGather,
} from '@/api/websiteGoodsGatherApi';
import {
  _queryWebsiteGoodsSeries,
  _querySeriesCategory,
} from '@/api/websiteGoodsSeriesApi';
import {
  _queryGoodsCategory
} from '@/api/websiteGoodsCategoryApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import DictSelect from '../../../components/DictSelect.vue';
import SimpleUploaderS3 from '@/components/SimpleUploaderS3.vue';

function treeGenerator(x, data, ignoreId) {
  const children = data
    .filter(child => child.value !== ignoreId && child.parentId === x.value && child.hbxLevel !== '3')
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

// 数据格式化
function formatData(data) {
  data.forEach((element) => {
    if (element.children && element.children.length > 0) {
      this.formatData(element.children);
    } else {
      element.children = undefined;
    }
  });
  return data;
}

async function getGoodsCategoryList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsGathers({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  if (result) {
    const categoryData = result.content.map(x => ({
      value: x.id,
      label: x.name,
      parentId: x.parentId,
    }));
    this.category.tree = [
      {
        value: null,
        label: '根节点',
        children: categoryData.filter(x => !x.parentId && x.value !== this.goodsCategoryId)
          .map(x => treeGenerator(x, categoryData, this.goodsCategoryId)),
      },
    ];
    this.category.tree = this.formatData(this.category.tree);
  }
  if (this.goodsCategoryId) {
    await this.getGoodsCategory();
  }
}

async function getGoodsCategory() {
  const result = await _queryGather(this.goodsCategoryId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.coverPath = result.coverPath;
    this.form.data.isPush = result.isPush;
    this.form.data.linkType = result.linkType;
    this.form.data.seriesId = result.seriesId;
    this.form.data.categoryId = result.categoryId;
    this.form.data.isRecommended = result.isRecommended;
  }
}

async function onAdd() {
  if (this.form.data.isRecommended === 'NO') {
    this.form.data.isPush = 'NO';
  }
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGather({
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        isPush: this.form.data.isPush,
        linkType: this.form.data.linkType,
        seriesId: this.form.data.seriesId,
        categoryId: this.form.data.categoryId,
        isRecommended: this.form.data.isRecommended,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  if (this.form.data.linkType === 'CATEGORY') {
    const result = await _queryGoodsCategory(this.form.data.categoryId);
    this.seriesId1 = result.seriesId;
  } else {
    this.seriesId1 = this.form.data.seriesId;
  }
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGather(this.goodsCategoryId, {
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        isPush: this.form.data.isPush,
        linkType: this.form.data.linkType,
        seriesId: this.seriesId1,
        categoryId: this.form.data.categoryId,
        isRecommended: this.form.data.isRecommended,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'WebsiteGoodsGatherEdit',
  components: {
    SimpleUploaderS3,
    DictSelect,
  },
  props: {
    goodsCategoryId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {

    goodsCategoryId() {
      if (this.goodsCategoryId) {
        this.getGoodsCategory();
      }
    },
    cascaderProps(val) {
      this.form.data.parentId = val[val.length - 1];
    },
    'form.data.type'(newVal, oldVal) {
      this.cascaderProps = [];
      this.category.tree = [];
      this.form.data.parentId = null;
      this.getGoodsCategoryList();
    }

  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsCategory,
    getGoodsCategoryList,
    treeGenerator,
    formatData,
  },
  data() {
    return {
      seriesId1: '',
      cascaderProps: [], // 联机属性
      series: {
        data: [],
      },
      category: {
        data: [],
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 999,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      form: {
        data: {
          name: '',
          coverPath: '',
          isPush: '',
          isRecommended: '',
          linkType: '',
          seriesId: '',
          categoryId: '',
        },
        title: '',
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
        },
      },
    };
  },
  async created() {
    await this.getGoodsCategoryList();
    const seriesResult = await _queryWebsiteGoodsSeries({});
    const seriesList = seriesResult.content;
    this.series.data = seriesList;

    const categoryResult = await _querySeriesCategory();
    const categoryList = categoryResult;
    this.category.data = categoryList;
  },
};
</script>
